import { BasicResult } from "../basic-result";

export class ProgramFeatures extends BasicResult{
    public TaskHopper:boolean = false;
    public Diary:boolean = false;
    public Reporting:boolean = false;
    public TechSupport:boolean = false;
    public AIFeatures:boolean = false;
    public Campaigns:boolean = false;
    public Events:boolean = false;
    public Dashboards:boolean = false;
    public ActionSummary:boolean = false;
    constructor(values: Object = {}) {
        super();
        Object.assign(this, values);
    }
}
